import getFormData from '@/utils/getFormData';

export default {
  methods: {
    isValid(formRef) {
      let isValid = false;

      if (this.$refs[formRef]) {
        this.$refs[formRef].validate(valid => {
          if (valid) {
            isValid = valid;
          }
        });
      }

      return isValid;
    },

    resetForm(formRef) {
      return this.$nextTick().then(() => {
        this.$refs[formRef] && this.$refs[formRef].resetFields();
      });
    },

    resetInput(input) {
      const form = document.createElement('form');
      const parent = input.parentNode;
      const { nextSibling } = input;

      form.appendChild(input);
      form.reset();

      // move the input back to where it was
      // if the input had a sibling, insert it before the sibling
      // otherwise, append it to the parent element
      parent.insertBefore(input, nextSibling);
    },

    getFormData,

    getFiles(e) {
      return e.target.files || e.dataTransfer.files;
    },
  },
};
